import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

import {
  withDefaults,
  useSlots,
  computed,
  ref,
  toRefs
} from 'vue'
import environment from '@/configs/environtment'
import Button from 'primevue/button'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'

interface IPropsButtonFileUpload {
  data?: any,
  inputId: string,
  buttonText: string
  buttonClassList: string
  isDisabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonPrimaryUpload',
  props: {
    data: { default: null as any },
    inputId: { default: '' },
    buttonText: { default: '' },
    buttonClassList: { default: 'btn-size-md' },
    isDisabled: { type: Boolean, default: false }
  },
  emits: ["X"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'X', val: any): any
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: any, inputId: string, buttonText: string, buttonClassList: string, isDisabled: boolean }

const slots = useSlots()



// const emit = defineEmits<{
//   (e: 'X', val: any): void
// }>()



const {
  data
} = toRefs(props)

const fileValue = computed({
  get: () => data.value,
  set: (v) => {
    emit('X', v)
  }
})

const onInputFileX = (file: any) => {
  // console.log('xxx', file)
  fileValue.value = file
}

const isProduction = computed(() => environment.getMode() === 'production')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ButtonFileUpload, { onOnInputFile: onInputFileX }, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          class: _normalizeClass(`flex items-center btn-primary ${_unref(isProduction) ? '' : 'stg'} ${__props.buttonClassList} ${_unref(slots).icon ? 'btn-icon' : ''}`),
          disabled: __props.isDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.isDisabled ? _ctx.onclick() : ''))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "icon"),
            _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
          ]),
          _: 3
        }, 8, ["class", "disabled"])
      ]),
      _: 3
    })
  ]))
}
}

})